import type { Action } from "../../actions/types";

export type StoreState = string;

export const initialState = "";

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  if (
    action.type === "SEND_MESSAGE_TO_MERCHANT" &&
    action.payload.type === "ELEMENT_CLICKED"
  ) {
    return action.payload.data || "";
  }

  if (action.type === "SET_SCREEN_NAME") {
    return "Screen";
  }

  return state;
}
